import { render, staticRenderFns } from "./teacherPlane.vue?vue&type=template&id=ec88a112&scoped=true"
import script from "./teacherPlane.vue?vue&type=script&lang=js"
export * from "./teacherPlane.vue?vue&type=script&lang=js"
import style0 from "./teacherPlane.vue?vue&type=style&index=0&id=ec88a112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88a112",
  null
  
)

export default component.exports